import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_PhotoReleaseForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_PhotoReleaseForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    I, <input type='text' id='txtLastName' name='txtLastName' className='add-only' />
                    (Parent/Legal Guardian, if minor) grant to <b>Life Solutions South</b>, its
representatives and employees the right to take photographs of me in connection with any activities I may
participate in connected with services offered by <b>Life Solutions South</b>. I authorize <b>Life Solutions South</b>, its
assigns and transferees to copyright, use and publish the same in print and/or electronically. <br />  <br />

I agree that <b>Life Solutions South</b> may use such photographs of me with / without (circle one) my name and for
any lawful purpose, including for example such purposes as publicity, illustration, advertising, and web content.<br />  <br />

I have read and understand the above:
                </p>

                <table>
                <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        </tr>
                        <tr>
                        <td className='small w-375'> Client Name (Printed) </td>
                        </tr>
                        <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Client Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Parent/Legal Guardian Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}